<template>
  <div class="admin-spe-btn-hld">
    <v-btn
      class="px-6 mr-2 cancel-standard"
      outlined
      color="#1c1d26"
      min-width="100px"
      @click="$router.push('/eventoverview#ManageMyEvents')"
    >
      <span class="d-inline-block mr-2"><img src="../assets/Images/icons/exit.svg" height="13px" width="13px"/></span>
      Exit
    </v-btn>
    <!-- <v-btn class="px-6 mr-2 cancel-standard" outlined color="#1c1d26" width="100px" @click="routeToNext('skipped')">
      Cancel
    </v-btn> -->
    <v-btn
      v-if="HasPreviewPage"
      class="px-6 mr-2 save-standard"
      dark
      color="#2376e5"
      min-width="100px"
      @click="goToPreviewPage"
      >Preview<v-icon color="#fff" size="15px" class="ml-2">mdi-eye-outline</v-icon>
    </v-btn>
    <v-btn
      v-if="showPrevNext('prev')"
      class="px-6 ml-4 save-standard"
      outlined
      dark
      color="#2376e5"
      min-width="100px"
      :loading="goingPrev"
      @click="onStepClick('visited', 'prev')"
      ><v-icon color="#2376e5" size="18px" class="mr-1">mdi-chevron-left</v-icon>Previous
    </v-btn>
    <v-btn
      v-if="showPrevNext('next')"
      class="px-6 ml-4 save-standard"
      outlined
      dark
      color="#2376e5"
      min-width="100px"
      :loading="goingNext"
      @click="onStepClick('visited', 'next')"
      >{{ $route.name == "EventSetup" ? "Save & Next" : "Next" }}<v-icon color="#2376e5" size="18px" class="ml-1">mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>
<script>
import db from "@/components/firebaseInit";
import ss_config from "@/assets/ss-config";
import { bus } from "@/main";
let vm;
export default {
  props: {
    HasPreviewPage: {
      type: Boolean,
      default: false,
    },
    MenuIDs: {
      type: Array,
      default: () => [],
    },
    eventId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ssMenu: [],
      direction: "next",
      goingPrev: false,
      goingNext: false,
    };
  },
  watch: {
    MenuIDs() {
      vm.getSSMenu();
    },
  },
  created() {
    vm = this;
    vm.getSSMenu();
    bus.$on("SaveStepStatus", (visited, saveStepStatus) => {
      vm.onStepClick(visited, vm.direction, saveStepStatus);
    });
    bus.$on("StopNextLoader", () => {
      vm.goingNext = false;
    });
  },
  methods: {
    getSSMenu() {
      vm.ssMenu = [];
      var ssConfigMenu = [...ss_config.SS_Menu];
      for (let i = 0; i < ssConfigMenu.length; i++) {
        if (ssConfigMenu[i].IsPublished) {
          if (
            ssConfigMenu[i].PreviewMenuId == 0 ||
            vm.MenuIDs.includes(ssConfigMenu[i].PreviewMenuId)
          ) {
            vm.ssMenu.push(ssConfigMenu[i]);
          }
        }
      }
    },
    showPrevNext(direction = "next") {
      var result = false;
      for (var i = 0; i < vm.ssMenu.length; i++) {
        let item = vm.ssMenu[i];
        if (item.routeName == vm.$route.name) {
          if (direction == "prev" && i > 0) {
            result = true;
          } else if (direction == "next" && i < vm.ssMenu.length - 1) {
            result = true;
          }
        }
      }
      return result;
    },
    async onStepClick(
      buttonTriggered = "notvisited",
      direction = "next",
      saveStepStatus = false
    ) {
      vm.direction = direction;
      if (direction == "prev") {
        vm.goingPrev = true;
      } else if (direction == "next") {
        vm.goingNext = true;
      }
      if (this.$route.name == "EventSetup" && !saveStepStatus) {
        bus.$emit("OnSaveAndNextEventInfo");
        return;
      }
      if (
        this.$route.name != "EventSetup" ||
        (this.$route.name == "EventSetup" && saveStepStatus)
      ) {
        bus.$emit("toggleLoader", true);
        await vm.updateStapeStepStatus(buttonTriggered);
        bus.$emit("toggleLoader", false);
        var result = vm.$route.name;
        result = vm.getStepURL(vm.direction);
        vm.goingPrev = false;
        vm.goingNext = false;
        vm.$router.push(result);
      }
    },
    getStepURL(direction) {
      var result = vm.$route.name;
      for (var i = 0; i < vm.ssMenu.length; i++) {
        let item = vm.ssMenu[i];
        if (item.routeName == vm.$route.name) {
          if (direction == "prev") {
            result = vm.ssMenu[i - 1].routeTo;
            if (result.includes("{{EventId}}")) {
              result = result.replace("{{EventId}}", vm.eventId);
            }
          } else if (direction == "next") {
            result = vm.ssMenu[i + 1].routeTo;
            if (result.includes("{{EventId}}")) {
              result = result.replace("{{EventId}}", vm.eventId);
            }
          }
        }
      }
      return result;
    },
    async updateStapeStepStatus(stepStatus) {
      await db
        .collection(vm.getEventCollectionName())
        .doc("EventInfo")
        .get()
        .then(async function (doc) {
          if (doc.exists) {
            let SS_Features = doc.data().SS_Features;
            var prevStatus = "";
            if (!SS_Features) {
              SS_Features = {};
            }
            if (
              SS_Features &&
              SS_Features[vm.$route.name] &&
              SS_Features[vm.$route.name].StepStatus
            ) {
              prevStatus = SS_Features[vm.$route.name].StepStatus;
            }
            if (["", "notvisited", "skipped"].includes(prevStatus)) {
              SS_Features[vm.$route.name] = {};
              SS_Features[vm.$route.name].routeName = vm.$route.name;
              SS_Features[vm.$route.name].StepStatus = stepStatus;
            }
            await db
              .collection(vm.getEventCollectionName())
              .doc("EventInfo")
              .update({ SS_Features: SS_Features })
              .then(async () => {
                //
              })
              .catch(async () => {
                //
              });
          }
        })
        .catch(async () => {
          //
        });
    },
    goToPreviewPage() {
      bus.$emit("goToPreviewPage");
    },
  },
};
</script>
